module.exports = __webpack_public_path__ + "img/einvoice-download-black.e869f77f.svg";